export const generateValidationMessage = (element, validationMessages) => {
    const message = { text: '', type: '' };
    const { validity } = element;
    const validityTypes = [];
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (const key in validity) {
        validityTypes.push(key);
    }
    validityTypes.sort().some((type) => {
        if (validity[type]) {
            message.type = type;
            if (type === 'customError') {
                message.text = element.validationMessage;
            }
            else {
                message.text = validationMessages[type] || '';
            }
        }
        return validity[type];
    });
    return message;
};
export const registerComponentHelper = (registerComponentFunc, args) => {
    if (registerComponentFunc) {
        registerComponentFunc(args);
    }
    else {
        // see https://gitlab.anwbonline.nl/anwb/common/frontend/poncho/-/issues/14
        // eslint-disable-next-line no-console
        console.warn('Cannot register FormInput component. See issue 14 in the Poncho Gitlab repo.');
    }
};
//# sourceMappingURL=form-helpers.js.map